module.exports = __webpack_public_path__ + "static/media/03.36c3253c.png";